import { useAuthStore } from "../stores/auth.store";
import { useBettorStore } from "@/stores/bettor.store";
import { useNotification } from "@kyvg/vue3-notification";
const baseUrl = process.env.VUE_APP_NODE_ENV === 'local' ? process.env.VUE_APP_LIST_CHECKER_API_URL : `${window.location.origin}`;
const notification = useNotification();
export const fetchWrapper = {
  get: request("GET"),
  post: request("POST"),
  put: request("PUT"),
  delete: request("DELETE"),
};

function request(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    if (body) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
    }
    try {
      return fetch(
        `${baseUrl}/${url}`,
        requestOptions
      ).then(handleResponse);
    } catch (error) {
      // Handle the error
      console.error('Error fetching data:', error.message);
    }
  };
} 

// helper functions

function authHeader(url) {
  // return auth header with jwt if user is logged in and request is to the api url

  const authStore = useAuthStore();
  const isLoggedIn = authStore.user;
  const isApiUrl = url;

  if (isLoggedIn && isApiUrl) {
    return {
      Authorization: `bearer ${authStore.user.access_token}`,
      "Api-token": process.env.VUE_APP_LIST_CHECKER_API_TOKEN,
    };
  } else {
    authStore.logout();
  }
}

async function handleResponse(response) {
  try {
    const isJson = response.headers
      ?.get("content-type")
      ?.includes("application/json");
    const data = isJson ? await response.json() : null;

    // check for error respthrow new Error(response.status);onse
    if (!response.ok) {
      const bettorStore = useBettorStore();
      const { user, logout } = useAuthStore();
      if ([401].includes(response.status) && user) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        logout();
      }
      if ([400].includes(response.status)) {
        // Do something specific for 400 Bad Request, e.g., show a notification 
        bettorStore.applicationStatus = true;
        // You can choose to return some specific value or just resolve the promise 
      }
      // get error message from body or default to response status
      const error = (data && data.message) || response.status;
      throw new Error(error);
    }

    const bettorStore = useBettorStore();
    const { logout } = useAuthStore();
    const application_status = response.headers?.get("application-status");
    const responseStatus = application_status;
    if (bettorStore.responseStatus !== responseStatus) {
      bettorStore.responseStatus = responseStatus;
      if (bettorStore.responseStatus === 200) {
        logout();
      }
    }

    return data;
  } catch (error) { 
  }
}

